<template>
  <div class="custom-form">
    <div class="area-context">
      <div class="context-label">{{ title }}</div>
      <div class="context-description">请填写您的咨询内容，我们将在第一时间与您联系</div>
    </div>
    <div class="area-btn flex-box pointer" @click="linkToForm(linkMap.demonstrateUrl)">
      <span>预约演示</span>
      <el-image :src="require('@/assets/images/link-to.png')" />
    </div>
  </div>
</template>

<script>
import { linkMap } from '@/utils'

export default {
  props: {
    title: {
      type: String,
      default: '更好用的PLM产品 / 璞华易研'
    }
  },
  data() {
    return {
      linkMap: linkMap
    }
  },
  methods: {
    linkToForm(url) {
      window.open(url)
    }
  }
}
</script>

<style lang="scss" scoped>
$img: "../../assets/images";

.custom-form {
  width: 100%;
  height: 36rem;
  background: url("#{$img}/yy1.png");
  background-size: cover!important;
  background-repeat: no-repeat!important;
  justify-content: space-between;
  align-items: center;

  .area-context {
    .context-label {
      font-weight: 600;
      font-size: 4.4rem;
      color: #FFFFFF;
      line-height: 4.8rem;
      text-align: center;
      font-style: normal;
      padding-top: 7.3rem;
    }
    .context-description {
      font-size: 2rem;
      font-weight: 400;
      color: #FFFFFF;
      text-align: center;
      line-height: 2rem;
      margin-top: 2.1rem;
    }
  }

  .area-btn {
    margin: 0 auto;
    margin-top: 6rem;
    font-size: 2rem;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 2rem;

    align-items: center;
    justify-content: center;
    width: 22rem;
    height: 6.4rem;
    border: 0.2rem solid #FFFFFF;

    span {
      margin-right: 0.8rem;
    }

    .el-image {
      width: 3rem;
      height: 3rem;
    }
  }
}

@import "@/styles/mixins.scss";

@include mobile {
  .custom-form {
    height: auto;
    padding-bottom: 4rem;

    .area-context {
      .context-label {
        font-size: 2.4rem;
        line-height: 3.2rem;
        padding: 4.8rem 1.6rem 0;
      }
      .context-description {
        font-size: 1.4rem;
        line-height: 2.2rem;
        padding: 0 1.6rem;
      }
    }

    .area-btn {
      width: 18rem;
      height: 4.8rem;
      font-size: 1.6rem;
      margin-top: 3.2rem;
    }
  }
}
</style>
